import { render } from "./SuperAdminsList.vue?vue&type=template&id=2f1f5086"
import script from "./SuperAdminsList.vue?vue&type=script&lang=js"
export * from "./SuperAdminsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__